/*
	depends on base.js
*/
import Dom from '../base/mdom.js';

import * as Base from '../base/mbase.js';
import QMAjax from '../base/ajax.js';
var getQueryStr = Base.getQueryStr;

import wxBridge from '../jsbridge/jsbridge_base.js';
let exportData;
(function (win) {
    var _qrStr = '',
        _opt = {
            loaded: false
        };
    var location = win.location;
    function initQryStr(url, _qajax, option) {
        var _url = '/cgi-bin/comm/genfun?';
        _qajax.uin = getQueryStr('uin', url);
        _qajax.key = getQueryStr('key', url);
        _qajax.pass_ticket = getQueryStr('pass_ticket', url);
        _qrStr = 'uin=' + _qajax.uin + '&key=' + _qajax.key + '&pass_ticket=' + _qajax.pass_ticket;
        _qajax.loginStr = _qrStr;
        _qajax.Referer = 'Referer=' + encodeURIComponent(location.href.split('#')[0]);
        // _qrStr += '&Referer=' + encodeURIComponent(location.href.split('#')[0])
        _qajax.method = _qajax.Referer != undefined ? 'POST' : 'GET';
        _qajax.url = _url + _qrStr + '&_=' + Math.random();
        if (option.loginCbk && typeof (option.loginCbk) == 'function') {
            option.loginCbk({
                uin: _qajax.uin,
                key: _qajax.key,
                from: _qajax.from,
                pass_ticket: _qajax.pass_ticket,
                loginStr: _qajax.loginStr
            });
        }
    }
    /*
    	{"ret":0,"msg":"","data":{"jsapi_sign":{"noncestr":"BuItzFysvMAQKPMB","signature":"a6f41d0e5acb43c254dc716986003d88316e11e6","timestamp":"1440757451"}}}
    */
    function asynVerifyCall(act, opt, cbk) {

        var _qajax = new QMAjax();
        _qajax.onComplete = function (xhr) {
            if (xhr.responseText.indexOf('{') != -1) {
                var res = JSON.parse(xhr.responseText);
                if (res.ret == 0) {
                    _opt.sign = res.data.jsapi_sign;
                    _opt.sign.loginStr = _qajax.loginStr;
                    _opt.sign.uin = _qajax.uin;
                    _opt.sign.key = _qajax.key;
                    _opt.sign.pass_ticket = _qajax.pass_ticket;
                    _opt.sign.from = _qajax.from;
                    _opt.loaded = true;

                    // var img = new Image();
                    // img.src = 'http://www.qq.com?v= _qajax.onComplete ' + xhr.responseText;
                    // document.body.appendChild(img);
                    
                    wxBridge.verifyCall(act, _opt.sign, cbk)
                } else {
                    cbk && cbk(false, {
                        err_code: 1,
                        loginStr: _qajax.loginStr,
                        uin: _qajax.uin,
                        key: _qajax.key,
                        from: _qajax.from,
                        pass_ticket: _qajax.pass_ticket,
                        err_msg: 'async signature load error'
                    });
                }
            }
            _qajax = null;
        };
        _qajax.onError = function (xhr, err_code) {
            cbk && cbk(false, {
                err_code: -1,
                xhr: xhr,
                loginStr: _qajax.loginStr,
                uin: _qajax.uin,
                key: _qajax.key,
                pass_ticket: _qajax.pass_ticket,
                err_msg: err_code
            });
            _qajax = null;
        };
        if (/uin=[^&]+/i.test(location.search)) {
            _qajax.from = 'url';
            initQryStr(location.search, _qajax, opt);
            _qajax.send(_qajax.Referer ? _qajax.Referer : null);
        } else {
            wxBridge.getA8key(function(urlObj,from){
                // alert('async get from ' + from + ' value:' + url);
                _qajax.from = from;
                var url = urlObj.full_url || urlObj.url;
                initQryStr(url, _qajax, opt);
                _qajax.send(_qajax.Referer ? _qajax.Referer : null);
            });
        }
    }
    wxBridge.asynVerifyCall = asynVerifyCall;
    exportData = wxBridge;
})(Dom.window);
export default exportData;